import { showModal } from './modal';

function qs(sel){ return document.querySelector(sel); }
function csrf(){ return document.querySelector('meta[name="csrf-token"]').getAttribute('content'); }

async function postJson(url, body){
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'X-CSRF-TOKEN': csrf() },
        body: JSON.stringify(body),
    });
    const data = await res.json().catch(()=> ({}));
    if (!res.ok || data.ok === false) {
        throw new Error(data.error || `HTTP ${res.status}`);
    }
    return data;
}

async function getJson(url){
    const res = await fetch(url, { headers: { 'Accept':'application/json' } });
    const data = await res.json().catch(()=> ({}));
    if (!res.ok || data.ok === false) throw new Error(data.error || `HTTP ${res.status}`);
    return data;
}

function renderContent(rows){
    const tbody = qs('#scaninfo-content-body');
    if (!rows || rows.length === 0){
        tbody.innerHTML = `<tr><td class="py-3 text-gray-500" colspan="4">Keine Scans.</td></tr>`;
        return;
    }
    tbody.innerHTML = rows.map(r => `
    <tr class="border-b">
      <td class="py-2 pr-3">${r.ean}</td>
      <td class="py-2 pr-3">${r.name || ''}</td>
      <td class="py-2 pr-3 font-semibold">${r.qty}</td>
      <td class="py-2 pr-3 whitespace-nowrap">${r.last_scan}</td>
    </tr>
  `).join('');
}

qs('#scaninfo-load')?.addEventListener('click', async () => {
    const en = e_number.value.trim().toUpperCase();
    if (!en) { showModal('Bitte E-Nummer eingeben.'); return; }

    try {
        const url = new URL(window.__SCANINFO_ENDPOINTS__.eboxDetails, window.location.origin);
        url.searchParams.set('e_number', en);
        const data = await getJson(url.toString());
        renderContent(data.content || []);
        renderHistory(data.history || []);
    } catch (e) {
        showModal(e.message);
    }
});

function renderHistory(rows){
    const tbody = qs('#history-body');
    if (!rows || rows.length === 0){
        tbody.innerHTML = `<tr><td class="py-3 text-gray-500" colspan="7">Noch keine Scans.</td></tr>`;
        return;
    }

    tbody.innerHTML = rows.map(r => {
        const print = r.print_status === 'printed'
            ? `<span class="text-green-700">OK</span>`
            : r.print_status === 'failed'
                ? `<span class="text-red-700">FEHLER</span>`
                : `<span class="text-gray-600">…</span>`;

        const price = (r.price != null) ? `${Number(r.price).toFixed(2)} €` : '—';

        const minusBtn = `<button data-minus="${r.id}" class="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300">-</button>`;

        return `
      <tr class="border-b">
        <td class="py-2 pr-3 whitespace-nowrap">${r.scanned_at}</td>
        <td class="py-2 pr-3">${r.ean}</td>
        <td class="py-2 pr-3">${r.name || ''}</td>
        <td class="py-2 pr-3 font-semibold">${r.qty_delta}</td>
        <td class="py-2 pr-3">${price}</td>
        <td class="py-2 pr-3">${print}</td>
        <td class="py-2 pr-3 text-right"></td>
      </tr>
    `;
    }).join('');
}

function setLast(scan){
    const lastLine = qs('#last-line');
    const lastMeta = qs('#last-meta');
    if (!scan) { lastLine.textContent = '—'; lastMeta.textContent = ''; return; }
    lastLine.textContent = `${scan.ean} – ${scan.name}`;
    lastMeta.textContent = `Preis: ${Number(scan.price).toFixed(2)} € | Druck: ${scan.print_status} | Zeit: ${scan.scanned_at}`;
}

function enableInputs(enabled){
    ['#supplier_id','#e_number','#ean','#btn-new-ebox'].forEach(id=>{
        const el = qs(id);
        if (!el) return;
        el.disabled = !enabled;
        el.classList.toggle('opacity-50', !enabled);
    });
}

async function loadHistoryForENumber(eNumber){
    const url = new URL(window.__SCANINFO_ENDPOINTS__.eboxDetails, window.location.origin);
    url.searchParams.set('e_number', eNumber);
    const res = await fetch(url.toString(), { headers: { 'Accept':'application/json' } });
    const data = await res.json().catch(()=> ({}));
    if (!res.ok || data.ok === false) return;
    renderHistory(data.history || []);
    renderContent(data.content || []);
}

function initScan(){
    if (!window.__SCANINFO_ENDPOINTS__) return;

    const supplier = qs('#supplier_id');
    const eNumber = qs('#e_number');
    const ean = qs('#ean');

    // Autofocus
    setTimeout(()=> ean?.focus(), 50);

    // Wenn E-Nummer geändert: History nachladen
    eNumber?.addEventListener('blur', async () => {
        const en = eNumber.value.trim();
        if (!en) return;
        await loadHistoryForENumber(en);
    });
}

document.addEventListener('DOMContentLoaded', initScan);
